import React from "react";

import { motion } from "framer-motion";

import { navItems } from "../../constants";

import { Link } from "react-router-dom";

import { useStateContext } from "../../context/ContextProvider";
import ToggleDark from "../utils/ToggleDark";
import ToggleLanguages from "../utils/ToggleLanguages";

function Navmobile({
  active,
  setOpenNavigation,
}) {

  const { currentDir } = useStateContext();

  return (

    <motion.div
      initial={{ opacity: 0, y: -40 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -40 }}
      transition={{ duration: 0.4 }}
      className="
        fixed
        top-[100px]
        left-0
        w-full
        z-[998]
        px-4
        lg:hidden
      "
    >

      <div
        className="
          rounded-[2rem]
          border border-white/10
          bg-white/10 dark:bg-black/20
          backdrop-blur-3xl
          shadow-2xl
          overflow-hidden
        "
      >

        <div className="p-5 flex flex-col gap-3">

          {
            navItems.map((item, index) => (

              <Link
                key={index}
                to={item.link}
                onClick={() => {
                  window.scrollTo(0, 0);
                  setOpenNavigation(false);
                }}
              >

                <motion.div
                  whileHover={{ x: 6 }}
                  whileTap={{ scale: 0.97 }}
                  className={`
                    flex items-center justify-between
                    rounded-2xl
                    px-5 py-4
                    transition-all duration-300
                    ${
                      active === index + 1
                        ? "bg-color-1 text-white shadow-lg"
                        : "bg-white/5 text-tcolor-4 dark:text-white hover:bg-white/10"
                    }
                  `}
                >

                  <span className="font-kufi text-base">

                    {
                      currentDir === "ltr"
                        ? item.titleEn
                        : item.titleAr
                    }

                  </span>

                  <div className="text-lg">
                    {item.icon}
                  </div>

                </motion.div>

              </Link>

            ))
          }

        </div>
        <div className="flex items-center w-full justify-center pb-3   gap-4">

<div className="rounded-xl bg-white/10 backdrop-blur-xl border border-white/10 p-2">
  <ToggleLanguages />
</div>

<div className="rounded-xl bg-white/10 backdrop-blur-xl border border-white/10 p-2">
  <ToggleDark />
</div>

</div>
      </div>

    </motion.div>
  );
}

export default Navmobile;

